/* Morgan Stanley makes this available to you under the Apache License,
 * Version 2.0 (the "License"). You may obtain a copy of the License at
 *      http://www.apache.org/licenses/LICENSE-2.0.
 * See the NOTICE file distributed with this work for additional information
 * regarding copyright ownership. Unless required by applicable law or agreed
 * to in writing, software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions
 * and limitations under the License. */

import type { AppIdentifier, BrowserTypes, Channel, DesktopAgent, PrivateChannel } from '@finos/fdc3';
import { IProxyMessagingProvider } from '../contracts.js';

/**
 * created to avoid circular dependencies
 */
export interface IChannelFactory {
    createPublicChannel(
        details: BrowserTypes.Channel,
        appIdentifier: AppIdentifier,
        messagingProvider: IProxyMessagingProvider,
    ): Channel;

    createPrivateChannel(
        details: BrowserTypes.Channel,
        appIdentifier: AppIdentifier,
        messagingProvider: IProxyMessagingProvider,
    ): PrivateChannel;
}

export type ContextListener = Pick<Channel, 'addContextListener' | 'getCurrentContext'> &
    Pick<DesktopAgent, 'getCurrentChannel'>;
